import React from 'react';
import { BoxIcon } from 'lucide-react';
interface MetricDisplayProps {
  icon: BoxIcon;
  label: string;
  value: string | number;
  subtext?: string;
  trend?: 'up' | 'down' | 'neutral';
  color?: string;
}
export function MetricDisplay({
  icon: Icon,
  label,
  value,
  subtext,
  trend,
  color = 'text-[var(--primary)]'
}: MetricDisplayProps) {
  return <div className="flex items-start gap-3 p-3 rounded-xl bg-white border border-gray-100 shadow-sm" data-id="element-163">
      <div className={`p-2 rounded-lg bg-gray-50 ${color}`} data-id="element-164">
        <Icon size={20} data-id="element-165" />
      </div>
      <div data-id="element-166">
        <p className="text-xs text-gray-500 font-medium" data-id="element-167">{label}</p>
        <p className="text-lg font-bold text-gray-900" data-id="element-168">{value}</p>
        {subtext && <p className="text-[10px] text-gray-400" data-id="element-169">{subtext}</p>}
      </div>
    </div>;
}